import styled from '@emotion/styled';
import {
  AngelusLogo,
  AngeplusLogo,
  APPLE_STORE_LINK,
  AppStoreBrandingMediumIcon,
  ButtonIconSecondaryMedium,
  ButtonNormalSecondarySmallIcon,
  CallOutlineMediumIcon,
  FacebookOutlineMediumIcon,
  InstagramOutlineMediumIcon,
  PLAY_STORE_LINK,
  PlayStoreBrandingMediumIcon,
  TextParagraph,
  token,
  WhatsappOutlineMediumIcon,
} from '@angeplus/prever-component-lib';
import { LinkWrapper } from '@angeplus/prever-component-lib/nextjs';

import {
  AUTH,
  BILLING,
  CLUBE,
  CONTRACT,
  MEDICAL_PARTNER,
  POSTHUMOUS,
  TELEVET,
  TERM,
} from '../../../routes';

const FOOTER_LINKS = {
  services: [
    { label: 'Cuidados e Saúde', href: MEDICAL_PARTNER },
    { label: 'Serviços Póstumos', href: POSTHUMOUS },
    { label: 'Para seu Pet', href: `${TELEVET}/home` },
    { label: 'Clube de vantagens', href: `${CLUBE}/home` },
  ],
  information: [
    { label: 'Politica de privacidade', href: `${TERM}/privacy-policy` },
    { label: 'Termos de uso', href: `${TERM}/terms-of-use` },
  ],
  associates: [
    { label: 'Area do cliente', href: AUTH },
    { label: 'Carteirinha digital', href: `${CONTRACT}/landing-page-card` },
    { label: 'Mensalidades do plano', href: BILLING },
  ],
  contact: {
    phone: '0800 006 6688',
    whatsapp: '0800 006 6688',
    whatsappLink:
      'https://wa.me/+558000066688?text=Ol%C3%A1%2C%20eu%20gostaria%20de%20informa%C3%A7%C3%B5es%20sobre%20o%20Plano%20Prever',
  },
};

const SOCIAL_LINKS = {
  instagram: 'https://www.instagram.com/angeplus',
  facebook: 'https://www.facebook.com/angeplus',
  whatsapp:
    'https://wa.me/+558000066688?text=Ol%C3%A1%2C%20eu%20gostaria%20de%20informa%C3%A7%C3%B5es%20sobre%20o%20Plano%20Prever',
};

export const ContactSection = () => {
  return (
    <ContactSectionContainer>
      <ContactContent>
        <FooterLinksGrid>
          <FooterColumn>
            <FooterColumnTitle>Serviços</FooterColumnTitle>
            <FooterLinksList>
              {FOOTER_LINKS.services.map((link) => (
                <FooterLinkItem key={link.label}>
                  <LinkWrapper href={link.href}>
                    <FooterLink>{link.label}</FooterLink>
                  </LinkWrapper>
                </FooterLinkItem>
              ))}
            </FooterLinksList>
          </FooterColumn>

          <FooterColumn>
            <FooterColumnTitle>Informações</FooterColumnTitle>
            <FooterLinksList>
              {FOOTER_LINKS.information.map((link) => (
                <FooterLinkItem key={link.label}>
                  <LinkWrapper href={link.href}>
                    <FooterLink>{link.label}</FooterLink>
                  </LinkWrapper>
                </FooterLinkItem>
              ))}
            </FooterLinksList>
          </FooterColumn>

          <FooterColumn>
            <FooterColumnTitle>Para Associados</FooterColumnTitle>
            <FooterLinksList>
              {FOOTER_LINKS.associates.map((link) => (
                <FooterLinkItem key={link.label}>
                  <LinkWrapper href={link.href}>
                    <FooterLink>{link.label}</FooterLink>
                  </LinkWrapper>
                </FooterLinkItem>
              ))}
            </FooterLinksList>
          </FooterColumn>

          <FooterColumn>
            <FooterColumnTitle>Fale conosco</FooterColumnTitle>
            <ContactInfo>
              <ContactPhone
                href={`tel:${FOOTER_LINKS.contact.phone.replace(/\s/g, '')}`}
              >
                {FOOTER_LINKS.contact.phone} (Telefone)
              </ContactPhone>
              <ContactWhatsApp href={FOOTER_LINKS.contact.whatsappLink}>
                {FOOTER_LINKS.contact.whatsapp} (WhatsApp)
              </ContactWhatsApp>
            </ContactInfo>
          </FooterColumn>
        </FooterLinksGrid>

        <LogoSection>
          <AngeplusLogo />
        </LogoSection>

        <AppDownloadAndDescriptionWrapper>
          <AppDownloadSection>
            <AppDownloadTitle>Baixe o aplicativo</AppDownloadTitle>
            <AppDownloadButtons>
              <LinkWrapper href={PLAY_STORE_LINK}>
                <ButtonNormalSecondarySmallIcon
                  icon={<PlayStoreBrandingMediumIcon />}
                >
                  Google Play
                </ButtonNormalSecondarySmallIcon>
              </LinkWrapper>
              <LinkWrapper href={APPLE_STORE_LINK}>
                <ButtonNormalSecondarySmallIcon
                  icon={<AppStoreBrandingMediumIcon />}
                >
                  App Store
                </ButtonNormalSecondarySmallIcon>
              </LinkWrapper>
            </AppDownloadButtons>
          </AppDownloadSection>

          <DescriptionSection>
            <DescriptionText>
              O Angeplus é a versão digital dos produtos e serviços do Grupo
              Angelus. A plataforma que traduz benefícios em soluções práticas
              para o seu dia a dia.
            </DescriptionText>
          </DescriptionSection>
        </AppDownloadAndDescriptionWrapper>

        <FooterDivider />

        <FooterBottom>
          <FooterBottomLeft>
            <GrupoAngelusLogo>
              <AngelusLogo />
            </GrupoAngelusLogo>
            <CopyrightText>
              © Angeplus 2022, Todos os direitos reservados
            </CopyrightText>
          </FooterBottomLeft>
          <SocialIcons>
            <LinkWrapper href={SOCIAL_LINKS.instagram} target="_blank">
              <ButtonIconSecondaryMedium>
                <InstagramOutlineMediumIcon
                  color={token.colors.solidAngeplusForeground}
                />
              </ButtonIconSecondaryMedium>
            </LinkWrapper>
            <LinkWrapper href={SOCIAL_LINKS.facebook} target="_blank">
              <ButtonIconSecondaryMedium>
                <FacebookOutlineMediumIcon
                  color={token.colors.solidAngeplusForeground}
                />
              </ButtonIconSecondaryMedium>
            </LinkWrapper>
            <LinkWrapper href={SOCIAL_LINKS.whatsapp} target="_blank">
              <ButtonIconSecondaryMedium>
                <WhatsappOutlineMediumIcon
                  color={token.colors.solidAngeplusForeground}
                />
              </ButtonIconSecondaryMedium>
            </LinkWrapper>
            <LinkWrapper
              href={`tel:${FOOTER_LINKS.contact.whatsapp.replace(/\s/g, '')}`}
            >
              <ButtonIconSecondaryMedium>
                <CallOutlineMediumIcon
                  color={token.colors.solidAngeplusForeground}
                />
              </ButtonIconSecondaryMedium>
            </LinkWrapper>
          </SocialIcons>
        </FooterBottom>
      </ContactContent>
    </ContactSectionContainer>
  );
};

const CONTENT_PADDING = '7%';

const ContactSectionContainer = styled.footer`
  background-color: ${token.colors.neutralXLight};
  padding: ${token.spacing.spacingXLarge} 0 ${token.spacing.spacingLarge} 0;
  width: 100%;

  @media (min-width: 768px) {
    padding: ${token.spacing.spacingXLarge} 0;
  }
`;

const ContactContent = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: ${token.spacing.spacingLarge};
`;

const FooterLinksGrid = styled.div`
  padding-top: ${token.spacing.spacingLarge};
  padding-left: ${CONTENT_PADDING};
  padding-right: ${CONTENT_PADDING};
  display: grid;
  grid-template-columns: 1fr;
  gap: ${token.spacing.spacingLarge};

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: ${token.spacing.spacingXLarge};
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;

const FooterColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${token.spacing.spacingSmall};
`;

const FooterColumnTitle = styled(TextParagraph)`
  color: ${token.colors.solidAngeplusForeground} !important;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: ${token.spacing.spacingXSmall};
  margin-top: 0;

  @media (min-width: 768px) {
    font-size: 18px;
  }
`;

const FooterLinksList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${token.spacing.spacingXSmall};
  list-style: none;
  padding: 0;
  margin: 0;
`;

const FooterLinkItem = styled.li`
  display: flex;
`;

const FooterLink = styled(TextParagraph)`
  color: ${token.colors.solidAngeplusForeground} !important;
  font-size: 14px;
  text-decoration: none;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.7;
  }

  @media (min-width: 768px) {
    font-size: 16px;
  }
`;

const ContactInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${token.spacing.spacingXSmall};
`;

const ContactPhone = styled.a`
  color: ${token.colors.solidAngeplusForeground} !important;
  font-size: 14px;
  font-family: ${token.typography.fontFamily01};
  text-decoration: none;
  transition: opacity 0.2s ease;
  margin: 0;
  line-height: 1.5;

  &:hover {
    opacity: 0.7;
  }

  @media (min-width: 768px) {
    font-size: 16px;
  }
`;

const ContactWhatsApp = styled.a`
  color: ${token.colors.solidAngeplusForeground} !important;
  font-size: 14px;
  font-family: ${token.typography.fontFamily01};
  text-decoration: none;
  transition: opacity 0.2s ease;
  margin: 0;
  line-height: 1.5;

  &:hover {
    opacity: 0.7;
  }

  @media (min-width: 768px) {
    font-size: 16px;
  }
`;

const LogoSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: ${CONTENT_PADDING};
  padding-right: ${CONTENT_PADDING};
  padding-top: ${token.spacing.spacingMedium};
  padding-bottom: ${token.spacing.spacingMedium};

  svg {
    width: 100%;
    height: auto;
  }

  @media (min-width: 768px) {
    padding-top: ${token.spacing.spacingLarge};
    padding-bottom: ${token.spacing.spacingLarge};
  }
`;

const AppDownloadAndDescriptionWrapper = styled.div`
  padding-left: ${CONTENT_PADDING};
  padding-right: ${CONTENT_PADDING};
  display: flex;
  flex-direction: column;
  gap: ${token.spacing.spacingMedium};
  align-items: center;

  @media (min-width: 968px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: ${token.spacing.spacingXLarge};
  }
`;

const DescriptionSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 100%;

  @media (min-width: 968px) {
    justify-content: flex-start;
    max-width: 50%;
  }
`;

const DescriptionText = styled(TextParagraph)`
  color: ${token.colors.solidAngeplusForeground} !important;
  font-size: 14px;
  text-align: center;
  line-height: 1.6;
  margin: 0;
  max-width: 100%;

  @media (min-width: 768px) {
    font-size: 16px;
  }

  @media (min-width: 968px) {
    text-align: left;
  }
`;

const AppDownloadSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${token.spacing.spacingSmall};
  width: 100%;

  @media (min-width: 968px) {
    align-items: flex-start;
    max-width: 50%;
  }
`;

const AppDownloadTitle = styled(TextParagraph)`
  color: ${token.colors.solidAngeplusForeground} !important;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  text-align: center;

  @media (min-width: 768px) {
    font-size: 20px;
  }

  @media (min-width: 968px) {
    text-align: left;
  }
`;

const AppDownloadButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${token.spacing.spacingSmall};
  width: 100%;
  max-width: 100%;

  @media (min-width: 480px) {
    flex-direction: row;
    justify-content: center;
    gap: ${token.spacing.spacingSmall};
  }

  @media (min-width: 968px) {
    justify-content: flex-start;
  }
`;

const FooterDivider = styled.hr`
  border: none;
  border-top: 1px solid ${token.colors.neutralLight};
  margin: ${token.spacing.spacingMedium} 0;
  width: 100%;

  @media (min-width: 768px) {
    margin: ${token.spacing.spacingMedium} 0 ${token.spacing.spacingXSmall} 0;
  }
`;

const FooterBottom = styled.div`
  padding-left: ${CONTENT_PADDING};
  padding-right: ${CONTENT_PADDING};
  padding-top: ${token.spacing.spacingXSmall};
  padding-bottom: ${token.spacing.spacingXSmall};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${token.spacing.spacingSmall};

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding-top: ${token.spacing.spacingXSmall};
    padding-bottom: ${token.spacing.spacingXSmall};
    min-height: 50px;
  }
`;

const FooterBottomLeft = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${token.spacing.spacingXSmall};

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: center;
    gap: ${token.spacing.spacingSmall};
  }
`;

const GrupoAngelusLogo = styled.div`
  display: flex;
  align-items: center;

  svg {
    height: 24px;
    width: auto;

    @media (min-width: 768px) {
      height: 26px;
    }
  }
`;

const CopyrightText = styled(TextParagraph)`
  color: ${token.colors.solidAngeplusForeground} !important;
  font-size: 12px;
  margin: 0;
  line-height: 1.4;

  @media (min-width: 768px) {
    font-size: 12px;
  }
`;

const SocialIcons = styled.div`
  display: flex;
  gap: ${token.spacing.spacingXSmall};
  align-items: center;

  @media (min-width: 768px) {
    gap: ${token.spacing.spacingSmall};
  }
`;
